<template>
  <el-row :gutter="5" style="border: 1px solid #eee;padding:5px;">
    <el-col :span="24">
      <el-tag
        style="margin-left:3px;"
        v-for="(mainBrand,index) in mainBrands"
        :closable="true"
        :close-transition="false"
        @close="handleClose(index)">
        {{mainBrand.brandName}}/{{mainBrand.seriesName}}
      </el-tag>
      <el-button v-show="mainBrands.length<=3" @click="addMainBrand" size="mini">选择主营品牌</el-button>
    </el-col>
    <el-col v-show="mainBrandVisit">
      <hr/>
      <el-col :span="11" >
        <el-select v-model="brand" @change="selectBrand" placeholder="请选择品牌">
          <el-option
            v-for="item in datas"
            :key="item.id"
            :label="item.name"
            :value="item.id+','+item.name+','+item.logo">
            <img :src="item.logo" style="width:25px;height:25px;float: left"></img>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="11">
        <el-select v-model="seriesValue" @change="selectSeries" placeholder="请选择车系">
          <el-option
            v-for="(item,index) in series"
            :key="item.id"
            :label="item.name"
            :value="index+''">
            <img :src="item.imgUrl"  style="width:25px;height:25px;float: left"></img>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
          </el-option>
        </el-select>
      </el-col>
    </el-col>

  </el-row>

  <!-- /.navbar-static-side -->
</template>

<script>
import BrandSeriesModel from '../framework/models/brandSeriesModel'
export default {
  name: 'brand-and-series-cascader',
  data: function (){
    return {
      mainBrands: [],
      brand: null,
      seriesValue: null,
      datas: [],
      series:[],
      cityPosition: null,
      countyPosition: null,
      areaCode: [],
      mainBrandData: {
        brandId: null,
        brandName: null,
        brandUrl: null,
        seriesId: null,
        seriesName: null,
        imageUrl: null
      },
      mainBrandVisit: false
    }
  },
  mounted: function () {
    this.loadBrands()
  },
  methods: {
    setMainBrand: function (mainBrandStr) {

      if(!mainBrandStr){
        return
      }

      this.mainBrands = JSON.parse(mainBrandStr)
    },
    addMainBrand: function () {
      this.mainBrandVisit = true
      this.brand = null
      this.seriesValue = null
    },
    selectSeries: function (index) {
      let items = this.series[index]
      this.mainBrandData.seriesId = items.id
      this.mainBrandData.seriesName = items.name
      this.mainBrandData.imageUrl = items.imgUrl

      let data = JSON.parse(JSON.stringify(this.mainBrandData))
      this.mainBrands.push(data)

      this.mainBrandVisit = false

      this.$emit('onSuccess',this.mainBrands)
    },
    handleClose: function (index) {
      this.mainBrands.splice(index,1)
      this.$emit('onSuccess',this.mainBrands)
    },
    resetData: function () {
      this.seriesValue = null
      this.brand = null
      this.mainBrands = []
    },
    selectBrand: function (selectItem) {

      let items = selectItem.split(',')
      let brandId = items[0]

      if(!brandId){
        return
      }

      let _this = this

      //得到品牌信息存储在主营品牌数据里面
      _this.mainBrandData.brandId = items [0]
      _this.mainBrandData.brandName = items [1]
      _this.mainBrandData.brandUrl = items[2]

      _this.seriesValue = null
      let params = {
        brandId: brandId
      }

      let listener = {
        success: function (dataInfo) {
          _this.series = dataInfo.datas
        }
      }
      BrandSeriesModel.findBaseSeriesByBrandIdForCDSystem(_this, params,listener)

    },
    loadBrands: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.datas
        }
      }
      BrandSeriesModel.findBaseBrandForCDSystem(_this, listener)
    }
  }
}
</script>
